export default __webpack_public_path__ + "static/media/Vistasis_A.47a4cc42.png";